export default __webpack_public_path__ + "7a3efd1b5f7e6580a094f91684bdf1e2.jpg";